let forms = document.querySelectorAll("form");

for (let form of Array.from(forms)) {

    form.addEventListener("submit", (e) => postForm(e, form));
}

function postForm(submitEvent, form) {
    submitEvent.preventDefault();
    let message = document.querySelector(".response-output");

    let submitButton = submitEvent.target.querySelector('input[type=submit]');

    submitButton.disabled = true;

    var formData = new FormData(form);
    formData.append("_url", window.location.href);

    fetch(submitEvent.target.action, {
        method: "post",
        body: formData
    }).then(response => {
        if (response.ok) {
            form.reset();
            submitButton.disabled = false;
            message.innerHTML =
                "<strong>Success!</strong> Your message was successfully sent.";
            form.classList.remove("error");
            form.classList.add("success");
            $('#submitResult').modal();
        } else {
            submitButton.disabled = false;
            message.innerHTML = "<strong>Error submitting, please contact us by phone.</strong>";
            form.classList.add("error");
            form.classList.remove("success");
            $('#submitResult').modal();
        }
    });

}
